
(function () {
  if (window.__bioMobileCountryMenuReady) return;
  window.__bioMobileCountryMenuReady = true;

  var dataNode = document.getElementById('mobile-country-menu-data');
  if (!dataNode) return;

  var config;
  try {
    config = JSON.parse(dataNode.content ? dataNode.content.textContent : dataNode.textContent);
  } catch (error) {
    return;
  }

  var menu = null;
  var activeTrigger = null;

  var pendingDesktopStore = null;

  function isDesktop() {
    return window.matchMedia('(min-width: 64em)').matches;
  }

  function normalizeCountryHandle(value) {
    var handle = String(value || '').toUpperCase();
    return handle === 'BU' ? 'BG' : handle;
  }

  function getLabels() {
    var language = (document.documentElement.lang || '').toLowerCase();
    var isChinese = language.indexOf('zh') === 0;
    var sharedTitle = String(config.title || '').trim();
    return {
      title: sharedTitle || (isChinese ? '選擇 國家及地區' : 'Choose country or region'),
      message: String(config.message || '').trim(),
      close: isChinese ? '關閉' : 'Close',
      update: isChinese ? '更新' : 'Update'
    };
  }

  function closeMenu() {
    if (!menu) return;
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-country-menu-open');
    if (activeTrigger) {
      activeTrigger.classList.remove('is-open');
      var activeButton = activeTrigger.querySelector('.country-select__select');
      if (activeButton) activeButton.setAttribute('aria-expanded', 'false');
    }
  }

  function normalizeShop(value) {
    return String(value || '')
      .replace(/^https?:/i, '')
      .replace(/^\/\//, '')
      .replace(/\/$/, '')
      .replace(/\.myshopify\.com$/i, '');
  }

  function chooseStore(store, option) {
    var selectedCountry = normalizeCountryHandle(config.currentCountry);
    var selectedHandle = normalizeCountryHandle(store.handle);
    if (selectedCountry === selectedHandle) {
      closeMenu();
      return;
    }

    option.setAttribute('aria-busy', 'true');
var targetUrl = String(store.link || '').trim();

if (targetUrl && !/^https?:\/\//i.test(targetUrl)) {
  targetUrl = 'https://' + targetUrl.replace(/^\/\//, '');
}

var currentHost = window.location.hostname
  .replace(/^www\./i, '')
  .toLowerCase();

var targetHost = '';

try {
  targetHost = new URL(targetUrl).hostname
    .replace(/^www\./i, '')
    .toLowerCase();
} catch (error) {
  targetHost = '';
}

if (targetUrl && targetHost && targetHost !== currentHost) {
  window.location.href = targetUrl;
  return;
}

    var body = new URLSearchParams();
    body.append('_method', 'put');
    body.append('country_code', selectedHandle);

    // Preserve the active Shopify language when switching Market.
    // This is especially important for Translate & Adapt pages such as /en/.
    var currentLanguage = String(document.documentElement.lang || '').trim();
    if (currentLanguage) {
      body.append('language_code', currentLanguage);
    }

    // Keep the visitor on the same localized page after the Market update.
    body.append('return_to', window.location.pathname + window.location.search);

    fetch('/localization', {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function (response) {
      if (!response.ok) throw new Error('Market update failed');
      window.location.reload();
    }).catch(function () {
      option.removeAttribute('aria-busy');
    });
  }

  function buildMenu() {
    if (menu) return menu;
    var labels = getLabels();
    menu = document.createElement('div');
    menu.className = 'mobile-country-menu';
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');

    var backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'mobile-country-menu__backdrop';
    backdrop.setAttribute('aria-label', labels.close);
    backdrop.addEventListener('click', closeMenu);

    var panel = document.createElement('div');
    panel.className = 'mobile-country-menu__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'mobile-country-menu-title');

    var header = document.createElement('div');
    header.className = 'mobile-country-menu__header';
    var title = document.createElement('h2');
    title.id = 'mobile-country-menu-title';
    title.className = 'mobile-country-menu__title';
    title.textContent = labels.title;
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'mobile-country-menu__close';
    close.setAttribute('aria-label', labels.close);
    close.textContent = '×';
    close.addEventListener('click', closeMenu);
    header.appendChild(title);
    header.appendChild(close);

    var list = document.createElement('div');
    list.className = 'mobile-country-menu__list';
    list.setAttribute('role', 'listbox');
    var current = String(config.currentCountry || '').toUpperCase();

    (config.stores || []).forEach(function (store) {
      if (!store || !store.handle) return;
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'mobile-country-menu__option';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', String(store.handle).toUpperCase() === current ? 'true' : 'false');

      var flag = document.createElement('img');
      var flagCode = String(store.handle || store.code || '').toLowerCase();
      if (flagCode === 'bu') flagCode = 'bg';
      var flagSource = String(store.flag || '');
      if (/\/bu\.svg(?:\?|$)/i.test(flagSource)) {
        flagSource = flagSource.replace(/\/bu\.svg/i, '/bg.svg');
      }
      flag.className = 'mobile-country-menu__flag';
      flag.src = flagSource || ('https://cdn.shopify.com/static/images/flags/' + flagCode + '.svg');
      flag.alt = '';
      flag.loading = 'lazy';
      flag.addEventListener('error', function () {
        var fallback = 'https://cdn.shopify.com/static/images/flags/' + flagCode + '.svg';
        if (flag.src !== fallback) flag.src = fallback;
      }, { once: true });

      var name = document.createElement('span');
      name.className = 'mobile-country-menu__name';
      name.textContent = store.name || store.code || store.handle;

      var currency = document.createElement('span');
      currency.className = 'mobile-country-menu__currency';
      currency.textContent = store.currency || '';

      option.appendChild(flag);
      option.appendChild(name);
      option.appendChild(currency);
      option.addEventListener('click', function () {
        if (isDesktop()) {
          pendingDesktopStore = store;
          Array.prototype.forEach.call(list.querySelectorAll('.mobile-country-menu__option'), function (item) {
            item.setAttribute('aria-selected', item === option ? 'true' : 'false');
          });
          return;
        }
        chooseStore(store, option);
      });
      list.appendChild(option);
    });

    panel.appendChild(header);
    if (labels.message) {
      var message = document.createElement('p');
      message.id = 'mobile-country-menu-message';
      message.className = 'mobile-country-menu__message';
      message.textContent = labels.message;
      panel.setAttribute('aria-describedby', message.id);
      panel.appendChild(message);
    }
    panel.appendChild(list);

    var footer = document.createElement('div');
    footer.className = 'mobile-country-menu__footer';
    var update = document.createElement('button');
    update.type = 'button';
    update.className = 'mobile-country-menu__update';
    update.textContent = labels.update;
    update.addEventListener('click', function () {
      if (pendingDesktopStore) chooseStore(pendingDesktopStore, update);
    });
    footer.appendChild(update);
    panel.appendChild(footer);
    menu.appendChild(backdrop);
    menu.appendChild(panel);
    document.body.appendChild(menu);
    return menu;
  }

  function openMenu(trigger) {
    activeTrigger = trigger;
    pendingDesktopStore = (config.stores || []).find(function (store) {
      return normalizeCountryHandle(store && store.handle) === normalizeCountryHandle(config.currentCountry);
    }) || null;
    var element = buildMenu();
    element.hidden = false;
    element.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-country-menu-open');
    trigger.classList.add('is-open');
    var button = trigger.querySelector('.country-select__select');
    if (button) button.setAttribute('aria-expanded', 'true');
    var selected = element.querySelector('[aria-selected="true"]');
    if (selected) selected.scrollIntoView({ block: 'center' });
    var close = element.querySelector('.mobile-country-menu__close');
    if (close) close.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.promo-banner__country-select .country-select');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openMenu(trigger);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu && !menu.hidden) closeMenu();
  });
})();
